import adminToolConfig from "./adminToolConfig";
import preference from "./preference";
import components from "./components.json";
import assetAllocation from "./assetAllocationConfig.json";
import labels from "@/locale/en-US/admintoolLabel.js";
const { language, currency } = preference.general;
export default {
    settings: {
        languageId: language,
        currency: currency,
        adminToolConfig: adminToolConfig,
        preference: preference,
        assetAllocation: assetAllocation,
        showRiskScore: true,
        includeRiskScoreColumn: true
    },
    components: components,
    labels: {
        en: labels,
        "en-US": labels
    }
};
